import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IPortfolioBuilding } from '@api/types'
import { PortfolioBuildingFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IProps {
  id: string
  assignmentPlanId?: string
}
interface IPayload {
  node: {
    name: string
    city: string
    id: string
    portfolio: IPortfolioBuilding
  }
}

const mutateHandler = handleFetchResult<IPayload, IPayload>({
  handler: (data) => data,
  name: 'Neighborhood Space',
})

export default function building({ id, assignmentPlanId }: IProps): Promise<IPayload> {
  const variables = {
    id,
    assignmentPlanId,
  }
  return client.gql.query({ query: buildingPortfolioQuery, variables }).then(mutateHandler)
}

export const buildingPortfolioQuery = gql`
  query buildingPortfolio($id: ID!, $assignmentPlanId: ID) {
    node(id: $id) {
      ... on Building {
        name
        city
        id
        portfolio(assignmentPlanId: $assignmentPlanId) {
          ...PortfolioBuildingFragment
        }
      }
    }
  }
  ${PortfolioBuildingFragment}
`
